import { J1DownarrowD } from '@e3dc-react/icons'
import { FormControl, MenuItem, Select } from '@mui/material'
import { SelectChangeEvent, SelectInputProps } from '@mui/material/Select/SelectInput'
import { useFormikContext } from 'formik'
import React from 'react'
import { DppBatteryStatus, DynamicPricesSettings } from '../../types'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import useActiveInstallationContext from 'src/Libs/installations/hooks/use-active-installation-context'
import { EmsProductType } from 'src/Routes/Installation/InstallationModel'

type Props = {
  dppBatteryStatus: DppBatteryStatus
  setDppBatteryStatus: (value: DppBatteryStatus) => void
  disabled?: boolean
}

/**
 * This is a dropdown component for the dpp battery feature status.
 * has three options: disabled, enabledWithDynamicEms, enabled
 */
const DppBatteryStatusDropdown: React.FC<Props> = ({ dppBatteryStatus, setDppBatteryStatus, disabled = false }) => {
  const { t } = useCustomTranslation()
  const { setFieldValue } = useFormikContext<DynamicPricesSettings>()
  const { storage } = useActiveInstallationContext()
  const isQntm = storage?.product === EmsProductType.qntm

  const handleChange: SelectInputProps<DppBatteryStatus>['onChange'] = (event: SelectChangeEvent) => {
    const value = event.target.value as DppBatteryStatus

    setDppBatteryStatus(value)
    switch (value) {
      case 'disabled':
        setFieldValue('isDynamicEmsEnabledForBattery', false)
        setFieldValue('dynamicPricesForBatteryEnabled', false)
        break
      case 'enabledWithDynamicEms':
        setFieldValue('isDynamicEmsEnabledForBattery', true)
        setFieldValue('dynamicPricesForBatteryEnabled', true)
        break
      case 'enabled':
        setFieldValue('isDynamicEmsEnabledForBattery', false)
        setFieldValue('dynamicPricesForBatteryEnabled', true)
        break
    }
  }

  return (
    <FormControl sx={{ width: '100%', maxWidth: 250, borderRadius: '20px', padding: 0 }}>
      <Select
        value={dppBatteryStatus}
        onChange={handleChange}
        IconComponent={J1DownarrowD}
        displayEmpty
        sx={theme => ({
          '.MuiSelect-select': {
            padding: theme.spacing('8.5px', '14px'),
          },
        })}
        disabled={disabled}
      >
        <MenuItem value="disabled">{t('systemSettings-dynamic-prices.battery.ems-based-toggle.disabled')}</MenuItem>
        {!isQntm && <MenuItem value="enabledWithDynamicEms">{t('systemSettings-dynamic-prices.battery.ems-based-toggle.enabled-with-ems')}</MenuItem>}
        <MenuItem value="enabled">{t('systemSettings-dynamic-prices.battery.ems-based-toggle.enabled-without-ems')}</MenuItem>
      </Select>
    </FormControl>
  )
}

export default DppBatteryStatusDropdown
